module.exports = __webpack_public_path__ + "static/media/it-infrastructure.b5e0fdf7.svg";